<template>
  <div class="footers">
    <div class="footer-log"></div>
    <div class="footer-log-br"></div>
    <div class="footer-text">
      <div class="footer-text-right" @click="rowCLick(1)">
        <p>网站首页</p>
      </div>
      <div class="footer-text-right" @click="rowCLick(route)">
        <p>产品样品</p>
      </div>
      <div class="footer-text-right" @click="rowCLick(3)">
        <p>了解更多</p>
      </div>
      <div class="footer-text-right" @click="rowCLick(4)">
        <p>注册开店</p>
      </div>
      <div
        style="display: inline-block; padding-left: 20px; cursor: pointer"
        @click="rowCLick(99)"
      >
        <p>联系我们</p>
      </div>
      <p class="footer-text-p">
        Copyright © 2021 广州市德财软件有限公司 版权所有
        <a href="https://beian.miit.gov.cn">粤ICP备2021037325号</a> Power by DCMY
      </p>
    </div>
    <div class="footer-er"></div>
  </div>
</template>

<script>
import but from "./but.js";
export default {
  data() {
    return {
      route: sessionStorage.getItem("route"),
    };
  },
  methods: {
    rowCLick(key) {
      // console.log(key);
      but.$emit("key", key);
      switch (key) {
        case 1:
          this.$router.push("/main");
          sessionStorage.setItem("route", "main");
          break;
        case "Marketing":
          // window.open("https://example.com", "_blank");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style>
.footers {
  width: 100%;
  height: 150px;
  background: linear-gradient(#a5a5a5, #5f6062);
  /* background: rgb(44, 43, 43); */
  /* background: rgb(98 98 98); */
  display: flex;
  justify-content: center;
  /* justify-content: flex-start; */
  padding-top: 80px;
  font-family: "楷体";
  color: white;
}
.footers a {
  color: aliceblue;
}
.el-footer {
  padding: 0;
}
.footer-log {
  width: 100px;
  height: 100px;
  background-image: url("../../assets/title.png");
  background-size: 100%;
  margin-left: 20%;
  margin-right: 20px;
}
.footer-log-br {
  height: 100px;
  width: 1px;
  background: rgb(133, 133, 133);
}
.footer-er {
  width: 100px;
  height: 100px;
  /* background-image: url('https://www.decaisoft.com:443/img/demay/img/er.png'); */
  background-image: url("https://www.decaisoft.com:443/img/demay_formal/img/er.png");
  background-size: 100%;
  margin-left: 120px;
}
.footer-text-right {
  padding: 0 20px;
  border-right: 1px solid rgb(129, 129, 129);
  display: inline-block;
}
.footer-text-right p:hover {
  cursor: pointer;
}
.footer-text-p {
  font-size: 12px;
  margin-left: 20px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue